import { DocumentStatut } from '@lib/ged/document.model';
import { DocumentStatutEnum } from '@graphql/generated';
export class DocumentStatutMapper {
  public static fromGraphQl(
    input?: DocumentStatutEnum | null
  ): DocumentStatut | undefined {
    const mapping: Record<DocumentStatutEnum, DocumentStatut> = {
      VALIDE: 'valide',
      A_CORRIGER: 'a_corriger',
      MIS_A_JOUR: 'mis_a_jour',
    };
    return input ? mapping[input] : undefined;
  }

  public static toGraphQl(input?: DocumentStatut | undefined): DocumentStatutEnum | null {
    const mapping: Record<DocumentStatut, DocumentStatutEnum> = {
      valide: DocumentStatutEnum.Valide,
      a_corriger: DocumentStatutEnum.ACorriger,
      mis_a_jour: DocumentStatutEnum.MisAJour,
    };
    return input ? mapping[input] : null;
  }
}
